'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headful = require('headful');

var _headful2 = _interopRequireDefault(_headful);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handler = function handler(props) {
    return (0, _headful2.default)(getPassedProps(props));
};

exports.default = {
    name: 'vue-headful',
    props: Object.keys(_headful2.default.props),
    watch: {
        '$props': {
            handler: handler,
            deep: true,
            immediate: true
        }
    },
    activated: function activated() {
        // required for keep-alive components https://vuejs.org/v2/api/#keep-alive
        handler(this.$props);
    },
    render: function render() {}
};


function getPassedProps(props) {
    return Object.keys(props).reduce(function (passedProps, propKey) {
        if (props[propKey] !== undefined) {
            passedProps[propKey] = props[propKey];
        }
        return passedProps;
    }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-headful/dist/vue-headful.js
// module id = 1625
// module chunks = 2